import React, { useEffect } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getNuggetByIdAction } from '../../../utils/redux/nuggets/nuggetAction';
import { useParams } from 'react-router-dom';
import '../CSS/commondetails.css';

const NuggetDetailsPage = () => {

    const { id } = useParams();
    const { selectedNugget } = useSelector(state => state.nuggets);

    const dispatch = useDispatch();

    const fetchNuggetDetails = async () => {
        await dispatch(getNuggetByIdAction(id));
    };

    useEffect(() => {
        fetchNuggetDetails();
    }, []);

    if (!selectedNugget)
        return <>Loading...</>;


    return (
        <Container className="py-4">
            <Card className="talk-details-card">
                <Card.Body>
                    {/* Title Section */}
                    <div className="title-section mb-4">
                        <h2>{selectedNugget?.title || "No title available"}</h2>
                    </div>

                    <Row className="mb-4">
                        {/* Basic Information Column */}
                        <Col md={6}>
                            <div className="detail-section">
                                <h5 className="section-title">Basic Information</h5>
                                <div className="info-content">
                                    <div className="detail-item">
                                        <span className="label">Duration:</span>
                                        <span>{selectedNugget?.durationHhmmss || "Duration not specified"}</span>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        {/* Links Column */}
                        <Col md={6}>
                            <div className="detail-section">
                                <h5 className="section-title">Links</h5>
                                <div className="info-content">
                                    <div className="detail-item">
                                        <span className="label">Nugget Link:</span>
                                        {selectedNugget?.link ? (
                                            <a href={selectedNugget?.link} target="_blank" rel="noopener noreferrer">
                                                Nugget Link
                                            </a>
                                        ) : (
                                            <span className="text-muted">No Nugget link available</span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Description Section */}
                    <div className="detail-section mb-4">
                        <h5 className="section-title">Transcription</h5>
                        <div className="content-section">
                            <div className="content-text formatted-text">
                                {selectedNugget?.transcription ?
                                    selectedNugget?.transcription.split('\n').map((paragraph, index) => (
                                        <p key={index}>{paragraph}</p>
                                    ))
                                    : "No Transcription added yet"}
                            </div>
                        </div>
                    </div>

                    {/* Summary Section */}
                    <div className="detail-section mb-4">
                        <h5 className="section-title">Summary</h5>
                        <div className="content-section">
                            <div className="content-text summary-background formatted-text">
                                {selectedNugget?.summary ?
                                    selectedNugget?.summary.split('\n').map((paragraph, index) => (
                                        <p key={index}>{paragraph}</p>
                                    ))
                                    : "No Details added yet"}
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    )
}

export default NuggetDetailsPage